import type {StockFavoriteIdentity} from '@Panels/stock-panel/stock-favorites.types';

export enum FavoriteButtonVariant {
  /** A translucent chip floating in a media tile's corner; the tile reveals it on hover. */
  MEDIA_OVERLAY = 'MEDIA_OVERLAY',
  /** A bare heart sitting in a row of actions, such as the audio card's; the row decides when it shows. */
  INLINE = 'INLINE',
}

export interface FavoriteButtonProps {
  identity: StockFavoriteIdentity;
  variant: FavoriteButtonVariant;
}

export interface FavoriteButtonVariantClasses {
  anchor: string;
  button: string;
}

export const FAVORITED_HEART_ICON = 'icon-heart-filled';
export const UNFAVORITED_HEART_ICON = 'icon-heart';

/** A tile's heart adds the one item on that tile. */
export const TILE_HEART_ADDED_ITEM_COUNT = 1;

export interface FavoriteHeartParams {
  isFavorited: boolean;
  isTogglePending: boolean;
  /** How many items a tap on the empty heart adds: the tile's one item, or the selection's items that are not favorites yet. */
  addedItemCount: number;
  requestToggle: () => Promise<unknown>;
}

/** The rejected action a failed toggle thunk resolves with; its payload is the server's error code. */
export interface FavoriteToggleRejection {
  payload: unknown;
}

export interface FavoriteHeart {
  heartIcon: string;
  accessibleLabel: string;
  toggleHeart: () => void;
}
